<template>
  <EmptyResourceNotification v-if="resource.children_ids.length < 1" :resource="resource" />
  <div v-else class="gallery">
    <div
      v-for="(row, rowIndex) in rows"
      :key="rowIndex"
      class="gallery__row"
    >
      <div
        v-for="(item, itemIndex) in row"
        :key="itemIndex"
        :class="{ 'gallery__item--single': row.length <= 1 }"
        class="gallery__item"
      >
        <Media :resource="item" />
      </div>
    </div>
  </div>
</template>

<script>
import { Resource } from 'beisheim/models'
import { chunk } from 'lodash'
import editable from '@i22/frontend-cms-utils/mixins/editable'
import Media from 'beisheim/components/blocks/media'
import EmptyResourceNotification from 'beisheim/components/elements/empty-resource-notification'

export default {
  components: {
    EmptyResourceNotification,
    Media
  },
  mixins: [ editable ],
  computed: {
    rows () {
      const resources = Resource.query().whereIdIn(this.resource.children_ids).orderBy('sort_key').get()

      if (!resources) {
        return []
      }

      return chunk(resources, 2)
    }
  },
  methods: {
    isSmall (rowIndex, itemIndex) {
      return itemIndex === 1
    }
  }
}
</script>

<style lang="scss">
@import 'beisheim/scss/scale';
@import 'beisheim/scss/grid';
@import 'beisheim/scss/breakpoints';

.gallery {
  margin-top: scale(30);
  margin-bottom: scale(30);
}

.gallery__row {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  max-width: $max-width;
  margin-left: auto;
  margin-right: auto;

  @include from(3) {
    margin-top: scale(20);
    margin-bottom: scale(20);

    &:first-child {
      .gallery__item:last-child {
        margin-top: scale(20);
        width: 50%
      }
    }

    &:nth-child(2n) {
      .gallery__item:first-child {
        margin-top: scale(20);
        width: 50%
      }
    }

    .gallery__item.gallery__item--single:first-child {
      width: 100%;
    }
  }
}

.gallery__item {
  margin-bottom: scale(5);

  @include from(3) {
    width: 40%;
  }

  &:first-child:not(:last-child) {
    margin-right: auto;

    @media (max-width: $max-width) {
      .media__meta {
        margin-left: scale(10);
      }
    }

    @include to(2) {
      @include grid-spacing(padding-right, 2)
    }
  }

  &:last-child:not(:first-child) {
    margin-left: auto;

    .media__meta {
      margin-right: scale(10);
    }

    @include to(2) {
      @include grid-spacing(padding-left, 2);
    }
  }

  &:first-child:last-child {

    @include to(2) {
      @include grid-spacing(padding-right, 2);
      margin-right: auto;
    }

    @include from(3) {
      @include grid-spacing(padding-left, 2);
      @include grid-spacing(padding-right, 2);
      width: 100%;
      margin: 0 auto;
    }
  }
}
</style>
